import { render } from "./OurOrders.vue?vue&type=template&id=5662667e"
import script from "./OurOrders.vue?vue&type=script&lang=js"
export * from "./OurOrders.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__